import * as React from 'react';
import { Button, Col, Row } from 'reactstrap';
import {
  CommunityFields,
  validateAccountId,
  validateCommunityAccountName,
} from './CommunityFields';
import { Form } from '@availity/form';
import { object, string, number, ref } from 'yup';
import '@availity/yup';
import { logger } from '../../../logging';

const CommunityFormValidation = object().shape({
  account_name: string().required(),
  account_id: string().required(),
  party_id: number().required(),
});

const accountStyles = require('../account.css');

const CommunityFormErrorCheck = ({
  errors,
  touched,
  isValidating,
  setHasFormErrors,
  setFormErrors,
  setFormTouched,
}) => {
  logger.debug(
    `[CommunityForm] CommunityFormErrorCheck errors: ${JSON.stringify(
      errors
    )}, touched: ${JSON.stringify(touched)}, isValidating: ${JSON.stringify(
      isValidating
    )}`
  );

  const hasErrors = Object.keys(errors).length > 0;
  logger.debug(
    `[CommunityForm] CommunityFormErrorCheck hasErrors: ${hasErrors}`
  );

  React.useEffect(() => {
    setFormErrors(errors);
    setHasFormErrors(hasErrors);
    setFormTouched(touched);
  });

  return null;
};

export const CommunityForm = ({
  canSave,
  model,
  save,
  account,
  system,
  setCanSave,
  decommissioningCommenced,
  decommissioningStatus,
}) => {
  const [hasFormErrors, setHasFormErrors] = React.useState(false);
  const [formErrors, setFormErrors] = React.useState({});
  const [formTouched, setFormTouched] = React.useState({});
  const defaultCommunityFormValues = {
    account_name: '',
    account_id: '',
    party_id: '',
    party_name: '',
    active: true,
    ...model,
  };

  const handleSubmit = async (values, { setFieldError }) => {
    logger.debug(
      `[CommunityForm] handleSubmit called: [ACTIVE]: ${JSON.stringify(
        values.active
      )} values: ${JSON.stringify(values)}`
    );

    // handle validateAccountName here validateCommunityAccountName
    const isAccountNameValid = await validateCommunityAccountName(
      values.account_name,
      values.id,
      setFieldError,
      setHasFormErrors
    );

    // handle async account_id validation
    const isAccountIdValid = await validateAccountId(
      values['account_id'],
      values['key'],
      setFieldError
    );

    logger.debug(
      `[CommunityForm] handleSubmit - [save about to be called] formErrors: ${JSON.stringify(
        formErrors
      )}, hasFormErrors: ${hasFormErrors}, isAccountNameValid: ${isAccountNameValid}, isAccountIdValid: ${isAccountIdValid}`
    );

    if (isAccountNameValid === true && isAccountIdValid === true) {
      await save(values, formErrors);
    }
  };

  const submitDisabled = !canSave || hasFormErrors || decommissioningCommenced;

  return (
    <Form
      initialValues={defaultCommunityFormValues}
      onSubmit={handleSubmit}
      validationSchema={CommunityFormValidation}
    >
      {({ errors, touched, isValidating }) => (
        <React.Fragment>
          <Row>
            <Col sm="12">
              <CommunityFields
                account_id={account && account.account_id}
                system={system}
                model={model}
                setCanSave={setCanSave}
                errors={errors}
                decommissioningCommenced={decommissioningCommenced}
                decommissioningStatus={decommissioningStatus}
              />
            </Col>
          </Row>
          <Button
            className={accountStyles.submitButton}
            type="submit"
            disabled={submitDisabled}
            color={submitDisabled ? 'secondary' : 'primary'}
          >
            Save
          </Button>
          <CommunityFormErrorCheck
            errors={errors}
            touched={touched}
            isValidating={isValidating}
            setHasFormErrors={setHasFormErrors}
            setFormErrors={setFormErrors}
            setFormTouched={setFormTouched}
          />
        </React.Fragment>
      )}
    </Form>
  );
};
